import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Loading from "../ui/loading";
import { getDateString } from "../utils/DateTimeUtils";
import { tienFormat } from "../utils/NumberUtils";
import { OneAPi } from "./oneApi";

type OwnProps = {

}
interface Statement {
    Date: string; // ISO Date string
    ProductType: number;
    Quantity: number;
    Amount: number;
    NetAmount: number;
    Commission: number;
    GrossCommission: number;
    WinLose: number;
}
interface State {
    statements: Statement[];
    isLoading: boolean;
}

const SaoKe: FC<OwnProps> = ({ }) => {
    const [state, setState] = useState<State>({
        statements: [],
        isLoading: true,
    })
    useEffect(() => {
        OneAPi.statements().then(res => {
            if (res) {
                setState(prev => ({ ...prev, statements: res, isLoading: false }))
            }

        })
    }, [])
    let totalWinLose = 0;
    if (state.isLoading) {
        return <Loading />
    }
    return <div>
        {state.statements.map((item: Statement, index: number) => {
            totalWinLose += item.WinLose;
            const result: any[] = []
            result.push(<div className="common-container-row" key={index}>
                <div> {getDateString(item.Date)}</div>
                <div style={item.WinLose < 0 ? 'color:red;' : ''}>{tienFormat(item.WinLose)} </div>
            </div>)
            if (index == state.statements.length - 1) {
                result.push(<div className="common-container-row" key={index + 1}>
                    <div> Tổng tuần này : </div>
                    <div style={totalWinLose < 0 ? 'color:red;' : ''}>{tienFormat(totalWinLose)} </div>
                </div>)
            }
            return result;
        })}
    </div>
}

export default memo(SaoKe)